import { forwardRef } from 'react';
import { RadioProps, Radio as TUIRadio } from '@apia/theme';

const Radio = forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
  return (
    <TUIRadio
      {...props}
      disabled={props.disabled || props.readOnly}
      onMouseDown={
        props.readOnly
          ? (ev) => {
              ev.preventDefault();
              props.onMouseDown?.(ev);
            }
          : undefined
      }
      onKeyDown={
        props.readOnly
          ? (ev) => {
              if (ev.code === 'Enter' || ev.code === 'Space')
                ev.preventDefault();
              props.onKeyDown?.(ev);
            }
          : undefined
      }
      ref={ref}
    />
  );
});

export default Radio;
